import React from 'react';
import PropTypes from 'prop-types';
import './result.css';
import {ResultForm} from "../resultForm/ResultForm";

const TestResult = props => {
  const { questions, count, testType, quizResults, group, quizName, updateStep, updateCount } = props;
  const calculatePercentage = Math.round((count / questions.length) * 100);
  let resultText = {
    title: '',
    comment: '',
    isLeadForm: false,
    resultButtonLink: '',
    resultButtonText: '',
    mailchimpTag: ''

  };
  const checkPercent = () => {
    switch (true) {
      case calculatePercentage <= 33:
        return 'result__count_bad';
      case calculatePercentage >= 66:
        return 'result__count_good';
      default:
        return '';
    }
  };

  const reloadTest = (e) => {
    e.preventDefault();
    updateCount(0);
    updateStep(0);
  }

  const checkInterval = (props, count) => {
    if(testType === 1) {
      quizResults.forEach(item => {
        if (count >= item.intervalFrom && count <= item.intervalTo) {
          resultText = {
            title: item.title,
            comment: item.comment,
            resultButtonText: item.resultButtonText,
            resultButtonLink: item.resultButtonLink,
            isLeadForm: item.isLeadForm,
            mailchimpTag: item.mailchimpTag,
            imageUrl: item.imageUrl
          };
        }
      });
    } else {
      const resultValue = group.sort((a,b) => 
          group.filter(v => v === a).length
          - group.filter(v => v === b).length
      ).pop();

      const result = quizResults.filter(el => {
        return el.groupName === resultValue
      })[0];
      resultText = {
        title: result.title,
        comment: result.comment,
        imageUrl: result.imageUrl
      }

      quizResults.forEach((el) => {
        if(el.id === result.id) {
          resultText.isLeadForm = el.isLeadForm;
          resultText.mailchimpTag = el.mailchimpTag;
        }
      })
    }
  };

  checkInterval(props, count);

  return (
    <div className="result">
      {testType === 1 && (
        <div className={`result__count ${checkPercent()}`}>
          {`${count}/${questions.length}`}
        </div>
      )}
      <h2 className="h2 result__title">{resultText.title}</h2>
      {resultText.imageUrl && (
          <div className="result__image">
            <img src={`https://ppc.world/quizzes/api${resultText.imageUrl}`} alt=""/>
          </div>
      )}
      <p
        className="result__Text"
        dangerouslySetInnerHTML={{ __html: resultText.comment }}
      />
      {resultText.resultButtonLink && resultText.resultButtonText && <a href={resultText.resultButtonLink}
                                                                        target="_blank"
                                                                        className="btn">{resultText.resultButtonText}</a>}
      {resultText.isLeadForm && (
            <ResultForm quizName={quizName} mailchimpTag={resultText.mailchimpTag}/>
      )}
      <div className="result__footer">
        <button className="result__btn btn btn_secondary"
                onClick={reloadTest}>
          Пройти еще раз
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="result__btn-logo">
            <path d="M7.25333 2.36743C4.28242 2.36743 1.87402 4.82987 1.87402 7.86743C1.87402 10.905 4.28242 13.3674 7.25333 13.3674C10.2242 13.3674 12.6326 10.905 12.6326 7.86743C12.6326 6.45878 12.1147 5.17382 11.2629 4.20077M11.2629 4.20077L9.94299 7.4091M11.2629 4.20077L14.874 5.11743"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

TestResult.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
  count: PropTypes.number.isRequired,
  resultText: PropTypes.object
};

export default TestResult;
